module.exports = __webpack_public_path__ + "static/media/placeholder9.f79d9af1.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder9.jpg
// module id = 631
// module chunks = 0